import firebase from 'firebase'


firebase.initializeApp({ 
    apiKey: "AIzaSyDTkj9vxPft-STsFw9M0lQpscqJB7DuoAk",
    authDomain: "habhab-5c64e.firebaseapp.com",
    projectId: "habhab-5c64e",
    storageBucket: "habhab-5c64e.appspot.com",
    messagingSenderId: "172178054380",
    appId: "1:172178054380:web:496dcf1f8c712127d5d9c9",
    measurementId: "G-6S2SG8NWB7"
})

firebase.analytics();
const db = firebase.firestore() 

export default db 